import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/Gamespage.css";
import ScrollToTop from "./Tiltop";


export const games = [
  // PC (holdspil)
  {
    id: 1,
    slug: "cs2",
    title: "Counter-Strike 2",
    platform: "pc",
    image: "/cs2banner.png",
    type: "team"
  },
  {
    id: 2,
    
    title: "Valorant",
    platform: "pc",
    image: "/valobanner.png",
    type: "team"
  },
  {
    id: 3,
    
    title: "League of Legends",
    platform: "pc",
    image: "/lolbanner.png",
    type: "team"
  },
  {
    id: 4,
    
    title: "Fortnite",
    platform: "pc",
    image: "/fortnitbanner.png",
    type: "team"
  },
  {
    id: 5,
    slug: "pubg",
    title: "Battlegrounds",
    platform: "pc",
    image: "/pubgbanner.png",
    type: "team"
  },
  {
    id: 6,
    slug: "tft",
    title: "Team fight tactics",
    platform: "pc",
    image: "/tftbanner.png",
    type: "team"
  },
  {
    id: 7,
    slug: "Roblox/minecraft",
    title: "Mincraft",
    platform: "pc",
    image: "/minbanner.png",
    type: "team"
  },
  {
    id: 8,
    slug: "Roblox/minecraft",
    title: "Roblox",
    platform: "pc",
    image: "/roblokbanner.png",
    type: "team"
  },

  // Nintendo (casual)
  {
    id: 9,
    slug: "Mario",
    title: "Mario Kart deluxe 8",
    platform: "nintendo",
    image: "/mariobanner.png",
    type: "casual"
  },
  {
    id: 10,
    slug: "Sport",
    title: "Sport",
    platform: "nintendo",
    image: "/sportbanner.png",
    type: "casual"
  },
  {
    id: 11,
    slug: "Crash",
    title: "Crash bandicoot",
    platform: "nintendo",
    image: "/crostbanner.png",
    type: "casual"
  },

  // VR
  {
    id: 12,
    slug: "Beat",
    title: "Beat Saber",
    platform: "vr",
    image: "/beatbanner.png",
    type: "casual"
  },
  {
    id: 13,
    slug: "job",
    title: "job simulator",
    platform: "vr",
    image: "/jobbanner.png",
    type: "casual"
  },
  {
    id: 14,
    slug: "superhot",
    title: "superhot ",
    platform: "vr",
    image: "/superbanner.png",
    type: "casual"
  },
  {
    id: 15,
    slug: "halflifealyx",
    title: "half-life alyx",
    platform: "vr",
    image: "/alyxbanner.png",
    type: "casual"
  },

  // PlayStation
  {
    id: 16,
    slug: "fifa",
    title: "FIFA 25",
    platform: "ps",
    image: "/fifabanner.png",
    type: "team"
  },

];





export default function GamePage() {
  const navigate = useNavigate();
  const pcGames = games.filter(game => game.platform === "pc");
  const nintendoGames = games.filter(game => game.platform === "nintendo");
  const vrGames = games.filter(game => game.platform === "vr");
  const psGames = games.filter(game => game.platform === "ps");


  return (
    <div className="gamepage">

      <section className="tekstplat">
        <h2>Spil vi tilbyder</h2>
        <p>Vi tilbyder en lang række af spil, både som holdspil og casual gaming.<br/> 
           Uanset om du er til konkurrence, samarbejde, eller bare vil spille for sjov,
           har vi noget for dig. <br/><br/> 
           Holdspil: Det kræver tilmelding for at kunne spille på et hold.<br/>  
           Casual gaming: spil frit så længe du er medlem</p>
      </section>


    <section
      className="platform"
    >
      <h3>Computer</h3>
      <p>Man skal tilmelde sig et hold for at kunne spille computer</p>
      
      <div className="card-grid">

      {pcGames.map(game => (
      <div
       key={game.id}
       className="game-plat"
       style={{ backgroundImage: `url(${game.image})` }}
       onClick={() =>navigate("/Gametime", { state: { selectedGame: game.slug } })}
      >
       <div className="card-overlay">
       <h3>{game.title}</h3>
       {game.type === "team" && (
      <button
        className="card-button"
        onClick={() =>navigate("/Gametime", { state: { selectedGame: game.slug } })}
      >
        Se holdtider
      </button>
      )}
     </div>
     </div>
      ))}
      </div>
    </section>


    <section
      className="platform"
    >
      <h3>PlayStation</h3>
      <p>Spil frit som medlem.</p>
      
      <div className="card-grid">

      {psGames.map(game => (
      <div
       key={game.id}
       className="game-plat"
       style={{ backgroundImage: `url(${game.image})` }}
       onClick={() =>navigate("/Gametime", { state: { selectedGame: game.slug } })}
      >
       <div className="card-overlay">
       <h3>{game.title}</h3>
       {game.type === "team" && (
      <button
        className="card-button"
        onClick={() =>navigate("/Gametime", { state: { selectedGame: game.slug } })}
      >
        Se holdtider
      </button>
      )}
     </div>
     </div>
      ))}
      </div>
    </section>

    

    <section
      className="platform"
    >
      <h3>Nintendo</h3>
      <p>Spil frit som medlem.</p>

      <div className="card-grid">
        {nintendoGames.map(game => (
          <div
            key={game.id}
            
            className="game-plat"
            
            style={{ backgroundImage: `url(${game.image})` }}
  
          >
            <div className="card-overlay">
              <h3>{game.title}</h3>
               {game.type === "team" && (
              <button
               className="card-button"
              >
               Se holdtider
              </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>




    <section
      className="platform"
    >
      <h3>VR (Virtual Reality)</h3>
      <p>Spil frit som medlem.</p>

      <div className="card-grid">
        {vrGames.map(game => (
          <div
            key={game.id}
            
            className="game-plat"
            
            style={{ backgroundImage: `url(${game.image})` }}
          >
            <div className="card-overlay">
              <h3>{game.title}</h3>
               {game.type === "team" && (
                <button className="card-button">Se holdtider</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
    <ScrollToTop />
    </div>
  );
}
